import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';
import { NineCellLoading } from 'react-loadingg';
import getNotificheWeb from '../../services/getNotificheWeb';
import translateString from "../../utils/Locales";

let t = translateString;

export default class Corsi extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.aule = [];
    this.pageTitle = "Notifiche";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });

    this.state = {
        isLoading: true,
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.notifiche = await getNotificheWeb(username, token);
    for (var n of this.notifiche){
      if (n.type == 'STUDENTE')
        n._name = n.studente;
      else if (n.type == 'INSEGNANTE')
        n._name = n.insegnante;
      else if (n.type == 'CORSO')
        n._name = n.corso;
    }

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();

  }


  render () {

    var headCells = [
      { id: 'date', numeric: false, disablePadding: true, label: t('data') },
      { id: 'type', numeric: false, disablePadding: true, label: t('tipologia') },
      { id: '_name', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'title', numeric: false, disablePadding: true, label: t('titolo') },
      { id: 'body', numeric: false, disablePadding: true, label: t('testo') },
    ];  

    this.searchCols = ['date', 'type', '_name', 'title', 'body'];
    
    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.notifiche == undefined) return <div />;
    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('notifiche')} />
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 10, marginLeft: 5 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('notifiche_info')}</p><br/>
          </div>

        <Table headCells={headCells} searchCols={this.searchCols} excel={false} calendar={false} mail={false} pdf={false} rows={this.notifiche}

        />
        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

